<template>
    <div>
        <p>"{{`brands.${game.brand}`  | lang }} {{ `titles.${game.name}` | lang}}" - {{'tv.how_to_play.lottery_every_5_min' | lang}}.</p>
        <p>"{{ `brands.${game.brand}`  | lang }} {{ `titles.${game.name}` | lang }}" {{'tv.how_to_play.everyting_in_your_hand' | lang}}.</p>
        <p>{{'tv.how_to_play.how_much_win' | lang}}.</p>
        <img class="img-fluid winning-table" :src="url('table')">
        <p>{{'tv.how_to_play.more_winners' | lang}}</p>

        <h6><strong>{{'tv.how_to_play.how_winning_calculated' | lang}}</strong></h6>

        <ul>
            <li>{{'tv.how_to_play.guessed_choosen' | lang}}.</li>
            <li>{{'tv.how_to_play.intersection' | lang}}.</li>
            <li>
                {{'tv.how_to_play.biggest' | lang}}. 
                "{{`brands.${game.brand}` | lang }} {{ `titles.${game.name}`  | lang }}" 
                {{'tv.how_to_play.prize' | lang}} - {{ maxWinAmount | currency }}.
            </li>
        </ul>

        <h6><strong>{{'tv.how_to_play.how_to_play' | lang}}</strong></h6>

        <ul>
          <li>{{'tv.how_to_play.choose_ticket_price' | lang}} -
            <span v-for="amount in amounts" :key="amount.id">{{amount.amount | currency}}; </span>
          </li>

          <li>{{'tv.how_to_play.choose_guessed_numbers_quantity' | lang}}.</li>

          <li>{{'tv.how_to_play.how_many_draws' | lang}}.</li>
          <li>{{'tv.how_to_play.choose_guessed_numbers' | lang}}.</li>
          <li>{{'tv.how_to_play.choose_random' | lang}} <fa-icon icon="random"></fa-icon>.</li>
          <li>{{'tv.how_to_play.press_button_to_start' | lang}} <strong>"{{ "buy_a_ticket" | lang }}"</strong>.</li>
        </ul>

        <p>
            <img class="img-fluid" :src="url('buy')">
        <p>
            {{'tv.how_to_play.actives_to_show'| lang}} <strong>"{{ "tickets" | lang }}" -> "{{ "active_tickets_short" | lang }}"</strong>
            {{'tv.how_to_play.wins_to_show'| lang}} <strong>"{{ "tickets" | lang }}" -> "{{ "history" | lang}}"</strong>.
        </p>

        <p>
            <img class="img-fluid" :src="url('actives_wins')">
        </p>

        <p>{{'tv.how_to_play.statistic_to_show_2' | lang}}.</p>

        <p>
            <img class="img-fluid" :src="url('stats')">
        </p>
        <p>
            <strong>{{'tv.how_to_play.important_1' | lang}}</strong>: {{'tv.how_to_play.important_2' | lang}} <strong>{{'tv.how_to_play.important_3' | lang}}</strong>.
        </p>

        <p>
            {{'tv.how_to_play.important_4' | lang}}
        </p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { tutorialMixin } from "@tv/mixins/tutorial";

    export default {
      mixins: [ tutorialMixin() ],
        computed: {
            ...mapGetters(['maxWinByGame']),
            maxWinAmount() {
                return this.maxWinByGame(this.game.id);
            },
            amounts() {
                if (this.game.id) {
                    return Config.games[this.game.id].amounts;
                }
            },
        },
    }
</script>